import styled from "styled-components";
import Variables from "../../../../assets/styleVariables";
export const Box = styled.div`
  position: relative;
  height: 100vh;

  .notfound {
    text-align: center;
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    max-width: 767px;
    width: 100%;
    line-height: 1.4;
    padding: 0 15px;
    .notfound-404 {
      position: relative;
      height: 150px;
      line-height: 150px;
      margin-bottom: 25px;
      h1 {
        font-family: Number;
        font-size: 80px;
        font-weight: 900;
        margin: 0;
        background: url("/images/text.png");
        -webkit-background-clip: text;
        -webkit-text-fill-color: ${Variables.colors.complementary_400};
        background-size: cover;
        background-position: center;
      }
    }

    p {
      font-family: IRANSans;
      font-size: 14px;
      font-weight: 500;
      color: ${Variables.colors.complementary_700};
      text-transform: uppercase;
      margin-bottom: 32px;
    }
  }
  @media only screen and (max-width: 767px) {
    .notfound-404 {
      height: 110px;
      line-height: 110px;
      h1 {
        font-size: 120px;
      }
    }
  }
`;
